import { useState } from 'react';
import { useSelector } from 'react-redux';
import { Outlet, useLocation, useParams } from 'react-router-dom';

import { usePublishedAdaptationPlans } from '@services/query.service';
import { useTranslation } from '@utils/i18n/i18n.consumers';
import { useMapBounds } from '@services/hooks.service';
import AdaptationListComponent from '../AdaptationListComponent';
import AdaptationStoryActionCard from '../../AdaptationStoryActionCard/AdaptationStoryActionCard';
import MapMarkerLayer from '../../MapMarkerLayer/MapMarkerLayer';
import { mapBoundsFilter } from '../adaptation-list-component.utils';

import './plans-list.styl';

function PlansList() {
  const [selectedMarker, setSelectedMarker] = useState(null);

  const location = useLocation();
  const { t } = useTranslation();

  const { data: adaptationPlans = [] } = usePublishedAdaptationPlans();
  
  const isCreateView = location.pathname.match(/\/adaptation\/plans\/create/);
  const map = useSelector(state => state.maplibremap.map);

  const mapBounds = useMapBounds(map);
  const filteredData = mapBoundsFilter(adaptationPlans, mapBounds);

  const { id } = useParams();
  
  return (
    <div className="plans-list">
      {id || isCreateView ? ( 
        <Outlet />
      ) : (
        <>
          <AdaptationListComponent selectedCategory="plans" />
          {filteredData.length === 0 && (
            <div className="all-list__no-data">
              <span>{t('No plans here yet. Zoom out or pan on the map to find more plans.')}</span>
            </div>
          )}
          <div className="all-list__cards">
            {filteredData.map(card => (
              <AdaptationStoryActionCard key={card.id} data={card} selectedData={selectedMarker} />
            ))}
          </div>
          <MapMarkerLayer
            markerData={adaptationPlans}
            setSelectedMarker={setSelectedMarker}
            selectedMarker={selectedMarker}
          />
        </>
      )}
    </div>
  );
}

export default PlansList;
